import { Preview } from "@creatomate/preview";

import { Organization, Story, Template } from "chq";

import setMontageCustomTemplate from "./setMontageCustomTemplate";
import sourceToSnakeCase from "./sourceToSnakeCase";

const setMontageTemplate = async (
  preview: Preview,
  organization: Organization,
  selectedStories: Story[],
  template: Template,
  onStoryUpdate?: (story: Story) => void,
  trend?: string
): Promise<void> => {
  const oldSource = preview.getSource();
  await preview.setSource(sourceToSnakeCase(template?.creatomateJson), true);
  if (onStoryUpdate) {
    await setMontageCustomTemplate(
      preview, organization, trend, oldSource, selectedStories, onStoryUpdate
    );
  }
};

export default setMontageTemplate;
